import React from 'react';

import { Popover, OverlayTrigger, Button } from "react-bootstrap";
import info from "Assets/Icons/info.svg";

const InfoBubble = ({message, title}) => {
  const infoMessage = <div style={{fontSize:"14px"}}>{message}</div>
  const infoPopover = <Popover>
                        <Popover.Content>
                          {infoMessage}
                        </Popover.Content>
                      </Popover>; 
  return (
    <OverlayTrigger trigger="click" placement="bottom" rootClose overlay={infoPopover}>
      <Button variant="Link" className="info-icon"><img className="top-menu-icon" alt="Info" src={info} /></Button>
    </OverlayTrigger>
  )
}

export default InfoBubble;